const helper = (navigate, setisLoader) => {
  localStorage.clear();
  setTimeout(() => {
    setisLoader && setisLoader(false);
  }, 1000);
  navigate && navigate("/");
};

export default helper;
